
import { get } from './http'
import { getJson } from './commonApi'

const numberOfItemsPerPage = 100;

// export async function getAppointmentEntities2(officerId) {
//   // Get the basic company information
//   const response = await get(`/entities2/appointmentEntities2/${officerId}`)
//   if (response.ok) {
//     let json = await response.json()
//     return json
//   }
// }

export async function getProfileEntity(companyNumber) {
  // Get the basic company information
  const response = await get(`/entities/profileEntity/${companyNumber}`)
  return getJson(await response.json())
}

export async function getAppointmentEntities(officerId, useLseData) {
  // Gets a list of up to 59 officer appointments
  // NB if page size is set to > 50, the Co Ho API call for appointments still only gets 50!
  const response = await get(`/entities/appointmentEntities/${officerId}/${useLseData}/50/${0}`);
  return getJson(await response.json())
}

export async function getCompanyEntities(companyNumber, links, companyStatusEnum, dateOfCreation, dateOfCessation) {
  links = encodeURIComponent(JSON.stringify(links))
  const response = await get(`/entities/companyEntities/${companyNumber}/${links}/${companyStatusEnum}/${dateOfCreation}/${dateOfCessation}/${numberOfItemsPerPage}/${0}`);
  return getJson(await response.json())
}
